var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patient-view message"},[_c('DirectMessageCard',{attrs:{"patient":_vm.patient}}),_c('SentMessageCard',{attrs:{"patient":_vm.patient}}),_c('ScheduledMessageCard',{attrs:{"patient":_vm.patient}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }